import dayjs from 'dayjs';

import {i18n} from '@yourcoach/i18n';

import type {NotificationEvent} from '../../../../../api/event';
import type {EventData} from '../types';

import {datetimeObjToISOString} from '../../../../../utils/datetime';
import {getYcLogoFile} from '../../../../../utils/entity/file';

export const getData = (event: NotificationEvent): EventData => {
  const availabilityEndDate = dayjs(datetimeObjToISOString(event.created)).add(
    6,
    'days',
  );

  return {
    avatar: getYcLogoFile(180),
    avatarPlaceholder: i18n.t('shared:your_coach'),
    title: i18n.t(
      'notifications:availability_needs_to_be_updated_week_before.title',
      {
        date: availabilityEndDate.format('ll'),
      },
    ),
  };
};
